import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { linkifyPhone } from "@/lib/phone";

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

interface FAQAccordionProps {
  faqs: FAQItem[];
  title?: string;
  className?: string;
}

export function FAQAccordion({ faqs, title = "Frequently Asked Questions", className = "" }: FAQAccordionProps) {
  return (
    <div className={`w-full max-w-3xl mx-auto ${className}`}>
      {title && (
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-foreground">
          {title}
        </h2>
      )}
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="border-b border-border py-2">
            <AccordionTrigger className="text-left font-medium text-lg hover:text-primary transition-colors">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground text-base leading-relaxed pt-2 pb-4">
              {linkifyPhone(faq.answer)}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
